<template>
  <div
    class="form-group form-tag focused"
    :class="{
      'has-error': errors[title] != undefined,
      checkDisabled: checkDisabled == true,
      disabled: $attrs.disabled == true,
    }"
  >
    <div class="checkDisabled" v-if="checkDisabled == true">
      <slot name="checkDisabled"></slot>
    </div>
    <ul
      class="form-control"
      :class="{
        'parsley-error': errors[title] != undefined,
      }"
    >
      <template v-if="$attrs.disabled != true">
        <li class="badge badge-info" v-for="item in model" :key="item">
          {{ item
          }}<i
            class="fas fa-times"
            @click="
              model = model.filter((x) => {
                return x != item;
              });
              $emit('update:modelValue', model);
            "
          ></i>
        </li>
      </template>
      <li>
        <input
          type="text"
          placeholder="..."
          :id="uid"
          class="form-control"
          v-show="$attrs.disabled != true"
          v-bind="$attrs"
          @keydown.enter="
            add($event.target.value);
            $event.target.value = '';
          "
        />
      </li>
    </ul>
    <Field
      type="hidden"
      :name="title"
      class="form-control"
      v-model="model"
      :rules="rules"
    >
      <slot name="input"></slot>
    </Field>
    <label class="control-label" :for="uid">{{ title }} </label>
    <label :for="uid" class="tagFocus"></label>
  </div>
</template>

<script>
// import searchSelectBox from "./searchSelectBox.vue";
export default {
  name: "formGroupTag",
  props: ["errors", "title", "modelValue", "rules", "checkDisabled"],
  // components:{searchSelectBox},
  data() {
    return {
      uid: this.$uniqueid(),
      test: "",
      model: this.modelValue,
    };
  },
  watch: {
    modelValue() {
      this.model = this.modelValue;
    },
  },
  methods: {
    add(val) {
      if (
        this.model.filter((x) => {
          return x == val;
        }).length == 0
      ) {
        this.model.push(val);
        this.$emit("update:modelValue", this.model);
      }
    },
  },
};
</script>

<style scoped></style>
